import "./bookingControls.css";

/** Shared per-booking control for upcoming and historical staff lessons. */
export function BookingConfirmationEmailControl({
  checked,
  disabled,
  onChange,
}: {
  checked: boolean;
  disabled: boolean;
  onChange: (checked: boolean) => void;
}) {
  return (
    <label className="booking-checkbox booking-confirmation-email small">
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      />
      <span>Send booking confirmation email to student</span>
    </label>
  );
}
